import { type CollectionType, type QueryItem } from '@directus/sdk';
import { type CustomDirectusTypes } from '@funnellab/shared/src/types/directus.ts';

export const simpleEntityQuery = {
  fields: ['id', 'label', 'icon', 'status'],
  sort: 'label',
  limit: -1,
} as const satisfies QueryItem<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, 'skill'>
>;

export const simpleEntityQueryWithRelevanceAndLanguage = {
  fields: ['id', 'label', 'label_en', 'icon', 'status', 'relevance'],
  sort: ['-relevance', 'label'],
  limit: -1,
} as const satisfies QueryItem<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, 'jobTitle'>
>;
